import { render, staticRenderFns } from "./ListView.vue?vue&type=template&id=68184278&scoped=true"
import script from "./ListView.vue?vue&type=script&lang=js"
export * from "./ListView.vue?vue&type=script&lang=js"
import style0 from "./ListView.vue?vue&type=style&index=0&id=68184278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68184278",
  null
  
)

export default component.exports